import { defineStore } from "pinia";
import { IDevice } from "../../models/Devices/device";
import { useDeviceStore } from "../device.store";
import { useParameterStore } from "../parameter.store";
import { useDevicePropertyStore } from "../deviceProperty.store";
import IDeviceProperty from "../../models/Devices/deviceProperty";

export const useBalanceStore = defineStore('balance', {
    state: () => ({
        selectedBalanceId: 0 as number,
        selectedBalanceProperties: [] as IDeviceProperty[],

        availableBalances: [] as IDevice[]
    }),
    getters: {
        hasActiveBalance(state) {
            return state.selectedBalanceId != 0;
        },

        selectedBalance(state) {
            return state.availableBalances.find(balance => balance.id == state.selectedBalanceId);
        }
    },
    actions: {
        init() {
            this.availableBalances = [];

            const deviceStore = useDeviceStore();
            const paramStore = useParameterStore();

            let balanceTypeIds = paramStore.getParametersByCode3Including("BALANCE|").map(p => p.id);

            for(const typeId of balanceTypeIds) {
                this.availableBalances = this.availableBalances.concat(deviceStore.getDeviceByTypeForCurrentCenter(typeId));
            }
    
            if(this.availableBalances.length > 0) {
                this.selectedBalanceId = this.availableBalances[0].id;
                this.refreshProperties();
            }
        },

        refreshProperties() {
            const devicePropertyStore = useDevicePropertyStore();
            devicePropertyStore.currentDeviceId = this.selectedBalanceId;
            this.selectedBalanceProperties = devicePropertyStore.getCurrentDeviceProperties;
        },

        async onBalanceSelected() {
            if(this.hasActiveBalance) {
                await this.refreshProperties();
            }
            else {
                console.error("No balance device for which to load properties found");
            }
        },

        async startListening() {
            if(this.hasActiveBalance) {
                const deviceStore = useDeviceStore();
                await deviceStore.registerMeasurementRequest(this.selectedBalanceId); 
            }
            else {
                console.error("No balance device found to process the listening request");
            }
        },

        async cancelListening() {
            if(this.hasActiveBalance) {
                const deviceStore = useDeviceStore();
                await deviceStore.cancelMeasurementRequest(this.selectedBalanceId); 
            }
            else {
                console.error("No balance device found to process the cancel request");
            }
        },

        // BEACONS
        startListeningBeacon() {
            if(this.hasActiveBalance) {
                const deviceStore = useDeviceStore();
                deviceStore.registerMeasurementBeaconRequest(this.selectedBalanceId); 
            }
            else {
                console.error("No balance device found to process the beacon request");
            }
        },

        cancelListeningBeacon() {
            if(this.hasActiveBalance) {
                const deviceStore = useDeviceStore();
                deviceStore.cancelMeasurementBeaconRequest(this.selectedBalanceId); 
            }
            else {
                console.error("No balance device found to process the beacon request");
            }
        }
    }
})